document.addEventListener('DOMContentLoaded', function () {
    const trackDownloads = function (loggedIn) {
        if (loggedIn) {
            // Digital Data Events tracking
            if (typeof (digitalData) !== 'undefined' && digitalData &&
          typeof (_satellite) !== 'undefined' && _satellite) {
                digitalData.events = [];
                const eventHolder = {
                    eventInfo: {
                        eventName: 'fxFileDownload',
                        eventAction: 'fileDownload',
                        eventId: Math.round(Math.random() * 10000000000)
                    }
                };
                digitalData.events.push(eventHolder);
                _satellite.track('mlcEvents');
            }
        }
    };

    const downloadURL = function (url) {
        window.open(url, '_blank');
    };

    const download = function (url, loggedIn, event) {
        trackDownloads(loggedIn);
        if (loggedIn) {
            event.preventDefault();
            downloadURL(url);
        }
    };

    document.querySelectorAll('a.link--download').forEach(function (link) {
        link.addEventListener('click', function (event) {
            const loginToDownload = this.dataset.logintodownload === 'true';
            download(this.href, !loginToDownload, event);
        });
    });
});
